<template>
  <div>
    <div :class="getDirectionOfRow">
      <BaseText
        v-if="orderType === OrderTypes.Sell"
        :color="getBalanceColor"
        size="sm"
      >
        <b>{{ computedBalanceValue }}</b>
      </BaseText>

      <template>
        <section class="balance_content">
          <BaseText
            v-if="isValidSell"
            size="sm"
            :color="NebraskaColors.textSecondary"
            class="balance_content__text"
          >
            Quantidade disponível
          </BaseText>
        </section>
      </template>
    </div>
    <span v-if="hasNotAvailableBalance" :class="getTitleFont">
      Deposite para continuar investindo.
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonIconContextual,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import { OrderType } from '../../types';
import { useDashStore } from '@/modules/common/store/DashModule';
import { NumberFormatted } from '@/modules/trade/types';

@Component({
  components: {
    BaseText,
    ButtonIconContextual,
    ListDisplay
  }
})
export default class AvailableBalance extends Vue {
  private readonly dashModule = useDashStore();

  @Prop({ type: Object, required: true })
  readonly balanceAvailable?: NumberFormatted;

  @Prop({ type: Boolean, default: false })
  readonly isRow!: boolean;

  @Prop({ type: String, default: '6' })
  readonly titleLevel!: string;

  @Prop({ type: String, default: '3' })
  readonly balanceLevel!: string;

  @Prop({ type: Number, default: 0 })
  readonly quantityAvailable!: number;

  @Prop({ type: Number, required: true })
  readonly orderType!: OrderType;

  readonly OrderTypes = OrderType;
  readonly NebraskaColors = NebraskaColors;

  get isValidSell() {
    return this.orderType === OrderType.Sell && this.quantityAvailable > 0;
  }

  get computedBalanceValue() {
    if (this.isValidSell) {
      return `${this.quantityAvailable} ativos`;
    } else if (this.orderType === OrderType.Buy) {
      return this.balanceAvailable?.formatted || '-';
    }

    return '';
  }

  get shouldShowMoney() {
    return this.dashModule.showMoney;
  }

  get hasNotAvailableBalance() {
    return !this.balanceAvailable?.value || this.balanceAvailable?.value <= 0;
  }

  get getDirectionOfRow() {
    const className = 'transaction_unrealized_balance';
    if (this.isRow) {
      return `${className}-row`;
    } else {
      return `${className}-column`;
    }
  }

  get getBalanceColor() {
    if (this.isRow) {
      return NebraskaColors.textSecondary;
    } else {
      return NebraskaColors.backgroundOverlay;
    }
  }

  get getTitleFont() {
    return [`text-p-${this.titleLevel}`, 'available-balance__text'];
  }

  get getBalanceFont() {
    return `text-p-${this.balanceLevel}`;
  }
}
</script>

<style lang="less" scoped>
.available-balance__text {
  color: @text-secondary;
}

.balance_content {
  display: flex;

  &__text {
    align-self: center;
  }

  &__icon {
    margin-right: @size-spacing-x75;
  }
}

.balance_placeholder {
  background: @element-secondary;
  border-radius: @size-radius-x100;
  width: @spacing-xxxl;
  height: @size-spacing-x500;
  float: right;
}

.transaction_unrealized_balance-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: @size-spacing-x500;
  p {
    user-select: none;
    align-self: flex-start;
  }
}

.transaction_unrealized_balance-row {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  p {
    user-select: none;
  }
  p:first-child {
    font-weight: bold;
  }
  p:last-child {
    margin-right: @size-spacing-x300;
  }
}
</style>
